module.exports = __webpack_public_path__ + "static/media/scooter.8036e583.jpg";